import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as MicroUtils from '../../utils';
import { env } from '@ivy/fts/envInfo/envInfo';
import { translateUrl } from '@/api/goods/statistics';
import { convertPxToVw } from '../../utils';
const mainSizeMap = {
    big: '18px',
    small: '16px',
};
const mainLineHeightMap = {
    big: '26px',
    small: '20px',
};
const subSizeMap = {
    big: '13px',
    small: '12px',
};
const subLineHeightMap = {
    big: '18px',
    small: '15px',
};
let Title = class Title extends Vue {
    get titleStyle() {
        return {
            'background-color': this.data.bgColor,
        };
    }
    get moreBtnRight() {
        return {
            right: this.data.mainTitle.compMargin + 'px',
        };
    }
    get mainStyle() {
        return {
            'padding-left': this.data.mainTitle.compMargin + 'px',
            'padding-right': this.data.mainTitle.compMargin + 'px',
            fontSize: mainSizeMap[this.data.mainTitle.fontSize],
            fontWeight: this.data.mainTitle.fontWeight,
            textAlign: this.data.mainTitle.fontAlign,
            color: this.data.mainTitle.fontColor,
            lineHeight: `${convertPxToVw(mainLineHeightMap[this.data.mainTitle.fontSize])}vw`,
            height: `${convertPxToVw(mainLineHeightMap[this.data.mainTitle.fontSize])}vw`,
        };
    }
    get subStyle() {
        return {
            'padding-left': this.data.subTitle.compMargin + 'px',
            'padding-right': this.data.subTitle.compMargin + 'px',
            fontSize: subSizeMap[this.data.subTitle.fontSize],
            fontWeight: this.data.subTitle.fontWeight,
            textAlign: this.data.subTitle.fontAlign,
            color: this.data.subTitle.fontColor,
            lineHeight: `${convertPxToVw(subLineHeightMap[this.data.subTitle.fontSize])}vw`,
            height: `${convertPxToVw(subLineHeightMap[this.data.subTitle.fontSize])}vw`,
        };
    }
    dataChange(newData) {
        console.log(newData);
    }
    async goLink() {
        let url = this.data.mainTitle.jumpUrl;
        if (!url)
            return;
        // 微页面组件内容点击埋点
        let translateRes = await translateUrl(url);
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: this.data.title,
            ContentName: this.data.mainTitle.value,
            JumpType: translateRes.jumpType,
            JumpContentName: translateRes.jumpName,
            JumpContentID: translateRes.jumpId,
            isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
            ['p3', 'isTabPage'],
            ['p4', 'JumpType_JumpContentID_JumpContentName'],
        ]);
        url && MicroUtils.goLink(url, env);
    }
};
tslib_1.__decorate([
    Prop()
], Title.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], Title.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Watch('data', { deep: true })
], Title.prototype, "dataChange", null);
Title = tslib_1.__decorate([
    Component({})
], Title);
export default Title;
